import { Trans, useTranslation } from 'react-i18next'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import {
    OreButton,
    OreStack,
    OreText,
} from '@edenredespana/oreneta'
import { navigationRoutes } from '@/Shared/ui/routers'
import { PlusCricleIcon } from '@/Shared/ui/assets/PlusCircle'
import { useNavigate, useParams } from 'react-router-dom'

export const TicketDetailFooterReOpen = (): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { ticketId } = useParams<{ ticketId: string }>()

    const handleReOpenTicket = () => {
        navigate(navigationRoutes.reopenTicket.replace(':ticketId', ticketId || ''))
    }


    return (
        <OreStack
            space="large"
            direction="column"
            placeContent="center"
            placeItems="center"
        >
            <OreText size="text-md" align="center">
                {t(HelpCenterTranslations.ticketDetail.footer.ticketReOpen)}
            </OreText>
            <OreButton
                category="primary"
                icon={<PlusCricleIcon />}
                onClick={handleReOpenTicket}
            >
                {t(HelpCenterTranslations.ticketDetail.footer.reOpenButton)}
            </OreButton>
            <OreText size="text-md" align="center">
                <Trans
                    i18nKey={HelpCenterTranslations.ticketDetail.footer.reOpenNewTicket}
                    components={[
                        <a
                            key="0"
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => navigate(navigationRoutes.newTicket)}
                        />,
                    ]}
                />
            </OreText>
        </OreStack>
    )
}
